import { $RTKGlobalAPI } from 'shared/store'

import { apiRoutes } from 'shared/config/apiPath/apiPath'

import { GetFAQArgs, GetFAQResponse } from './types'

const query = $RTKGlobalAPI.injectEndpoints({
  endpoints: builder => ({
    getFAQ: builder.query<GetFAQResponse, GetFAQArgs>({
      query: query => ({
        url: apiRoutes.faq.getFAQ,
        params: query,
      }),
    }),
  }),
})

export const { useGetFAQQuery, endpoints: faqEndpoints } = query
